export const circleIcon = require("../assets/circle.png");
export const crossIcon = require("../assets/cross.png");
export const plusIcon = require("../assets/plus.svg");
export const deleteIcon = require("../assets/delete.png");